import { createSlice } from '@reduxjs/toolkit'

// Added alongside RestaurantsSlice rather than folded into it: `restaurants`
// is read in several places as a bare array (`state.restaurants.map(...)`),
// so it can't carry a `{items, settled}` shape without touching every one of
// them. This tracks only whether the last getRestaurants() request finished
// (success or failure) — the thing a "restaurants is empty" check on its own
// can't tell apart from "still loading".
export const RestaurantsStatusSlice = createSlice({
  name: 'restaurantsStatusSlice',
  initialState: { settled: false },
  reducers: {
    restaurantsRequested(state) {
      state.settled = false
    },
    restaurantsSettled(state) {
      state.settled = true
    },
  },
})

export default RestaurantsStatusSlice.reducer
